var map = {
	"./ADA.svg": 691,
	"./BCH.svg": 692,
	"./BNB.svg": 693,
	"./BTC.svg": 694,
	"./CHZ.svg": 695,
	"./DASH.svg": 696,
	"./DOGE.svg": 697,
	"./DOT.svg": 698,
	"./ETC.svg": 699,
	"./ETH.svg": 700,
	"./EUR.svg": 701,
	"./GBP.svg": 702,
	"./LINK.svg": 703,
	"./LTC.svg": 704,
	"./MATIC.svg": 705,
	"./MKR.svg": 706,
	"./SHIB.svg": 707,
	"./SOL.svg": 708,
	"./TRX.svg": 709,
	"./UNI.svg": 710,
	"./USD.svg": 711,
	"./USDT.svg": 712,
	"./XLM.svg": 713,
	"./XMR.svg": 714,
	"./XRP.svg": 715,
	"./documents.svg": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;